export default __webpack_public_path__ + "static/bravo-3-d1623b8d00575bda78a18697a6daebd1.jpg";